import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { Servicejob } from 'src/app/_model/servicejob';

export class UnassignServicejobRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    sjob: Servicejob,
    appService: AppService,
    credentialsService: CredentialsService,
    private logger?: LoggingService
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'unassignservicejob',
        data: {
          sjobid: sjob.id.imsId,
          sjobkey: sjob.accountingnumber
            ? sjob.accountingnumber
            : sjob.appaccountingnumber,

          skey: sjob.accountingnumber
            ? sjob.accountingnumber
            : sjob.appaccountingnumber,
          sobjref: sjob.id.objRef,
          objRef: sjob.id.objRef,
          objId: sjob.id.imsId,
        },
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: 'UNASSIGN-SERVICEJOB-REMOTE-ACTION-BUILDER.RA.SHORT.LABEL',
        shortLabelTranslate: true,
        longLabel: sjob?.label,
        longLabelTranslate: false,
      },
      [],
      async (data: any) => {
        this.logger.log(
          this.constructor.name,
          ' Executing post generate function'
        );
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }
}
